import script from "./ScheduleAppointmentPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleAppointmentPanel.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleAppointmentPanel.vue?vue&type=style&index=0&id=bedddd7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bedddd7a"]])

export default __exports__